import { AuthContext } from '@repo-level/core-front';
import { someGroupMember, USER_GROUP } from 'helpers/user';
import { useContext, useMemo } from 'react';

export const usePromoRestrictions = () => {
  const { user, isAuthenticated, pendingUser } = useContext(AuthContext);

  const hasUserAccess = useMemo(() => {
    if (pendingUser || !isAuthenticated) return true;
    return !someGroupMember([USER_GROUP.BH, USER_GROUP.BA, USER_GROUP.VIPBA])(
      user
    );
  }, [user, isAuthenticated, pendingUser]);

  return { hasUserAccess };
};
